import {$} from '../jquery-definition.js';
import {CountUp} from 'countup.js';
import 'is-in-viewport';

$( function() {
	countUp();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		countUp();
	}, 100 );
} );

export function countUp() {
	$( '.block-count, .countup' ).each( function() {
		var $this = $( this );

		var count;
		var value = $this.attr( 'data-end-value' );
		var start = $this.attr( 'data-start-value' ) || 0;
		var prefix = $this.attr( 'data-prefix' ) || '';
		var suffix = $this.attr( 'data-suffix' ) || '';
		var separator = $this.attr( 'data-separator' );
		var countOptions = {
			separator: separator,
			decimal: ',',
			duration: 2,
			startVal: start,
			prefix: prefix,
			suffix: suffix,
		};

		if ( $this.is( ':in-viewport' ) ) {
			if ( !$this.hasClass( 'counted' ) ) {
				if ( $this.hasClass( 'count-float' ) ) {
					countOptions.decimalPlaces = parseInt( $this.attr( 'data-decimal-places' ) );
					count = new CountUp( $this[ 0 ], parseFloat( value ), countOptions );
				} else {
					count = new CountUp( $this[ 0 ], parseInt( value ), countOptions );
				}

				if ( !count.error ) {
					count.start();
				} else {
					console.error( count.error );
				}
			}

			$this.addClass( 'counted' );
		}
	} );
}
